import React from 'react';
import { FormCardContextType, initialState } from './types';

export const FormContext = React.createContext<Partial<FormCardContextType>>(initialState);
